import React from 'react';
import { observer } from 'mobx-react';
import { WeaTimePicker } from 'ecCom';

interface Props {
    value?: string;
    valueSpan?:string;
    viewAttr:string;
    onChange: (string) => void;
    ecId?:string;
}

export default observer((props: Props) => {
    const { onChange,value,viewAttr } = props;
    return (
        <div style={{float:'left'}}>
        <WeaTimePicker ecId={`${props && props.ecId || ''}_WeaTimePicker@1rsm8z`} noInput
        value={value}
        viewAttr={viewAttr}
        onChange={onChange}
    />
        </div>
    )
});


// WEBPACK FOOTER //
// ../src4js/pc4mobx/cube/src/components/list/littleCard/table-cell/WeaTimePicker.tsx